<template>
  <div :class="this.css">
    <transition name="modal">
      <div class="answer-modal" v-show="showWrong">
        <div class="intro-block">
          <div class="bg-left"></div>
          <div class="bg-right"></div>
          <div class="afishaLink">
            <a @click="$ga.event('Ссылка', 'Афиша', 1)" href="https://www.afisha.ru/"  target="_blank"><span class="afisha"></span></a>
          </div>
          <div class="shareBlock">
            <share-block></share-block>
          </div>
          <div class="container flex-b-center">
            <div>
              <div class="modal-photo"><img :src="this.image" alt=""></div>
              <div class="content">
                <div class="wrong_title">
                  {{wrong.title}}
                </div>
                <div class="wrong_text">
                  {{wrong.text}}
                </div>
                <button class="wrong" @click="closeModal(false)">Попробовать еще раз</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="modal">
      <div class="answer-modal" v-show="showCorrect">
        <div class="intro-block">
          <div class="bg-left"></div>
          <div class="bg-right"></div>
          <div class="afishaLink">
            <a @click="$ga.event('Ссылка', 'Афиша', 1)" href="https://www.afisha.ru/"  target="_blank"><span class="afisha"></span></a>
          </div>
          <div class="shareBlock">
            <share-block></share-block>
          </div>
          <div class="container flex-b-center">
            <div>
              <div class="modal-photo"><img :src="this.image" alt=""></div>
              <div class="content">
                <div class="correct_text" :style="this.correct.style">
                  {{correct.text}}
                </div>
                <button class="correct" @click="closeModal(true)">Читать далее</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="question-block" :class="{reversed: this.reversed && this.$resize && this.$mq.above(768)}">
      <div class="question">
        <h1 class="title">{{title}}</h1>
        <div class="line"></div>
        <ul class="answers">
          <li class="answer" v-for="variant in variants" @click="showModal(variant.correct)">
            <div class="title">{{variant.title}}</div>
            <div class="text">{{variant.text}}</div>
          </li>
        </ul>
      </div>
      <div class="image"><img :src="this.image" alt=""></div>
    </div>
  </div>
</template>

<script>
import "../assets/scss/page.scss";
import ShareBlock from "../components/ShareBlock";

export default {
  name: "Question",
  props: ["data"],
  data() {
    return {
      ...this.data,
      showCorrect: false,
      showWrong: false
    };
  },
  methods: {
    showModal(correct) {
      if (correct === true) {
        this.showCorrect = true;
        this.$ga.event(
          "Вопрос",
          `Правильный ответ ${this.css} №${this.n} (${this.title})`,
          1
        );
      } else {
        this.showWrong = true;
        this.$ga.event(
          "Вопрос",
          `Неправильный ответ ${this.css} №${this.n} (${this.title})`,
          1
        );
      }
      document.body.classList.add("modal-open");
    },
    closeModal(correct) {
      this.showCorrect = false;
      this.showWrong = false;
      if (correct === true) {
        this.$emit("correct");
      }
      document.body.classList.remove("modal-open");
    }
  },
  components: {
    ShareBlock
  }
};
</script>

<style scoped lang="scss">
.question-block {
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  &.reversed {
    flex-direction: row-reverse;
  }
}

.line {
  background-color: rgba(53, 53, 53, 0.3);
  width: 300px;
  height: 1px;
  margin: 0;
}

.question {
  width: 48%;
  .title {
    font-family: "Playfair Display", serif;
    color: rgba(50, 50, 50, 0.9);
    font-size: 40px;
    font-weight: 700;
    font-style: italic;
    line-height: 50px;
    margin-bottom: 0;
  }
}

.answers {
  list-style: none;
  padding-left: 0;
  .answer {
    cursor: pointer;
    margin-top: 20px;
    transition: all 100ms ease-in-out;
    &:hover {
      transform: scale(1.02);
    }
  }
  .title {
    font-size: 20px; /* Приближение из-за подстановки шрифтов */
    font-weight: 700;
    font-style: normal;
    margin: 0;
    line-height: normal;
  }
  .text {
    font-size: 14px; /* Приближение из-за подстановки шрифтов */
    font-weight: 400;
    line-height: 20px; /* Приближение из-за подстановки шрифтов */
    text-align: left;
  }
}

.answer-modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fbfbfb;
  transition: opacity 0.3s ease;
  max-height: 100vh;
  overflow-y: auto;
}

.bg-left {
  position: absolute;
  left: 0;
  top: 0;
  background: url("../assets/img/svetlana/bg-left.png");
  height: 100%;
  width: 40%;
  background-repeat: no-repeat;
  z-index: -1;
  background-size: contain;
  background-position: center left;
}

.bg-right {
  position: absolute;
  right: 0;
  top: 0;
  background: url("../assets/img/svetlana/bg-right.png");

  height: 100%;
  width: 40%;
  background-repeat: no-repeat;
  z-index: -1;
  background-size: contain;
  background-position: center right;
}

.svetlana {
  .bg-left {
    background-image: url("../assets/img/svetlana/bg-left.png");
  }
  .bg-right {
    background-image: url("../assets/img/svetlana/bg-right.png");
    max-width: 345px;
  }
}

.elena {
  .bg-left {
    background-image: url("../assets/img/elena/bg-left.png");
    max-width: 209px;
  }
  .bg-right {
    background-image: url("../assets/img/elena/bg-right.png");
    max-width: 222px;
  }
}
.maria {
  .bg-left {
    position: absolute;
    left: 0;
    top: 0;
    background: url("../assets/img/maria/bg-left.png");
    height: 100%;
    width: 40%;
    background-repeat: no-repeat;
    z-index: -1;
    background-size: contain;
  }

  .bg-right {
    position: absolute;
    right: 0;
    top: 0;
    background: url("../assets/img/maria/bg-right.png");
    height: 100%;
    width: 40%;
    background-repeat: no-repeat;
    z-index: -1;
    background-size: contain;
    background-position: top right;
  }
}

.modal-photo {
  margin: 0 auto;
  width: 130px;
  img {
    width: 100%;
    height: auto;
  }
}

.wrong_title {
  font-family: "Playfair Display", serif;
  color: rgba(50, 50, 50, 0.9);
  font-size: 36px; /* Приближение из-за подстановки шрифтов */
  font-weight: 700;
  font-style: italic;
  line-height: 50px; /* Приближение из-за подстановки шрифтов */
  text-align: center;
}

.wrong_text {
  font-family: "Playfair Display", serif;
  color: rgba(50, 50, 50, 0.9);
  font-size: 24px; /* Приближение из-за подстановки шрифтов */
  font-weight: 400;
  font-style: italic;
  text-align: center;
}

.answer-modal {
  .container {
    max-width: 800px;
  }
}

button {
  font-weight: 100;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  background: none;
  padding: 10px 10px;
  border: 1px solid;
  margin: 20px auto;
  display: block;
  &.correct {
    color: #b7874f;
    border-color: #b7874f;
  }
}

.correct_text {
  font-family: "Playfair Display", serif;
  font-size: 50px;
  font-style: italic;
  text-align: center;
  color: #c9a368;
  margin: 10px 0;
}

@media screen and (max-width: 768px) {
  .question-block {
    flex-direction: column-reverse;
    .image {
      width: 50vmin;
      img {
        width: 100%;
      }
    }
    .question {
      width: 100%;
      .title {
        font-size: 20px; /* Приближение из-за подстановки шрифтов */
        line-height: 20px;
        text-align: center;
        margin-top: 4px;
      }
      .line {
        width: 110px;
        margin: 7px auto;
      }
    }
    .answers {
      .text {
        font-size: 12px; /* Приближение из-за подстановки шрифтов */
        font-weight: 400;
        line-height: 15px; /* Приближение из-за подстановки шрифтов */
        text-align: center;
        margin-top: 7px;
      }
    }
  }

  .modal-photo {
    margin-top: 10vh;
  }
  .wrong_title {
    font-size: 14px;
    line-height: normal;
  }
  .wrong_text {
    font-size: 12px;
  }
  .shareBlock {
    display: none;
  }
  .correct_text {
    font-size: 20px !important;
  }
  .bg-left,
  .bg-right {
    background-position: top center;
  }
  .svetlana {
    .bg-left {
      background-image: url("../assets/img/svetlana/bg-left-mobile.png");
    }
    .bg-right {
      background-image: url("../assets/img/svetlana/bg-right-mobile.png");
    }
  }
  .elena {
    .bg-left {
      background-image: url("../assets/img/elena/bg-left-m.png");
    }
    .bg-right {
      background-image: url("../assets/img/elena/bg-right-m.png");
    }
  }
  .maria {
    .bg-left {
      background-image: url("../assets/img/maria/bg-left-mobile.png");
    }
    .bg-right {
      background-image: url("../assets/img/maria/bg-right-mobile.png");
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question.vue